import TemplateView from "../../TemplateView"
import {getCustomerIdsForExport, getIsCustomersAsc, getProjectIdsForExport} from './selectors'
import {connect} from "../../redux/utils"

class ExportCPDropdown extends TemplateView{
    constructor() {
        super(null)

        this.state = {
            customerIdsForExport: [],
            projectIdsForExport: [],
            isCustomersAsc: true
        }

        this.onStatePropertyChanged('customerIdsForExport', customerIdsForExport => {
            this.state.customerIdsForExport = customerIdsForExport;
            this.exportCPDropdown.setProps({ customerIds: customerIdsForExport });
        })
        this.onStatePropertyChanged('projectIdsForExport', projectIdsForExport => {
            this.state.projectIdsForExport = projectIdsForExport;
            this.exportCPDropdown.setProps({ projectIds: projectIdsForExport });
        })
        this.onStatePropertyChanged('isCustomersAsc', isCustomersAsc => {
            this.state.isCustomersAsc = isCustomersAsc;
            this.exportCPDropdown.setProps({ isGroupsAsc: isCustomersAsc });
        })
    }

    templateHtml(){
        return "<div class='atNextMount exportCPMount'></div>";
    }

    afterRender()
    {
        this.exportCPDropdown = ClassicBridge.integrateExportCPDropdown(this.$el[0], {
            triggerClassName: "exportCPDropdownTrigger",
            triggerButtonClassName: "exportCPDropdownTriggerButton",
            isGroupsAsc: this.state.isCustomersAsc,
            customerIds: this.state.customerIdsForExport,
            projectIds: this.state.projectIdsForExport
        })
    }
}

export default connect(
    (state) => ({
        customerIdsForExport: getCustomerIdsForExport(state),
        projectIdsForExport: getProjectIdsForExport(state),
        isCustomersAsc: getIsCustomersAsc(state)
    })
)(ExportCPDropdown)



// WEBPACK FOOTER //
// ./web/js/taskManagement/customersProjectsPanel/ExportCPDropdown.js